export default "__VITE_ASSET__UBOK_iDT__"